import Loading from '@kopapro/components/commons/loading/loading';
import { withTranslation } from 'react-i18next';

export default withTranslation()(Loading);
